import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REQUEST } from ".";
import {
  lesson3dModelingAPI,
  lesson3dPrintingAPI,
  lessonBettriesAPI,
  lessonBrushedBrushlessAPI,
  lessonElectricalEngineerAPI,
  lessonESCsBESCEsAPI,
  lessonFusionAPI,
  lessonGearRatiosAPI,
  lessonMaterialscienceAPI,
  lessonPCBsAPI,
  lessonPhysicsgeometryAPI,
  lessonReceiversAPI,
  lessonSlicingAPI,
  lessonSolderingAPI,
  lessonThinkercadAPI,
  lessonWeaponPhysicsAPI,
} from "../../routes/apiEndPoints";

export const transformLessonData = (data) => {
  return data?.length > 0
    ? data.map((item) => ({
        ...item,
        title: item?.lesson_title ?? "",
        text: item?.lesson_description ?? "",
        image: item?.lesson_cover_image ?? "",
      }))
    : [];
};

// "fetch-lessons-electrical-engineer"
export const fetchlessonelectricalEngineer = createAsyncThunk(
  "fetch-lessons-electrical-engineer",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonElectricalEngineerAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-PCBs"
export const fetchlessonPCBs = createAsyncThunk(
  "fetch-lessons-PCBs",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonPCBsAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-ESCsBESCEs"
export const fetchlessonESCsBESCEs = createAsyncThunk(
  "fetch-lessons-ESCsBESCEs",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonESCsBESCEsAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-batteries"
export const fetchlessonBatteries = createAsyncThunk(
  "fetch-lessons-batteries",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonBettriesAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-receivers"
export const fetchlessonReceivers = createAsyncThunk(
  "fetch-lessons-receivers",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonReceiversAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-physics-geometry"
export const fetchlessonPhysicsgeometry = createAsyncThunk(
  "fetch-lessons-physics-geometry",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonPhysicsgeometryAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-material-science"
export const fetchlessonMaterialscience = createAsyncThunk(
  "fetch-lessons-material-science",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonMaterialscienceAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-soldering"
export const fetchlessonSoldering = createAsyncThunk(
  "fetch-lessons-soldering",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonSolderingAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-brushed-brushless"
export const fetchlessonBrushedBrushless = createAsyncThunk(
  "fetch-lessons-brushed-brushless",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonBrushedBrushlessAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-weapon-physics"
export const fetchlessonWeaponPhysics = createAsyncThunk(
  "fetch-lessons-weapon-physics",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonWeaponPhysicsAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-gear-ratios"
export const fetchlessonGearRatios = createAsyncThunk(
  "fetch-lessons-gear-ratios",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonGearRatiosAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-3d-modling"
export const fetchlesson3dModeling = createAsyncThunk(
  "fetch-lessons-3d-modling",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lesson3dModelingAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-thinkercad"
export const fetchlessonThinkercad = createAsyncThunk(
  "fetch-lessons-thinkercad",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonThinkercadAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-lessons-fusion"
export const fetchlessonFusion = createAsyncThunk(
  "fetch-lessons-fusion",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonFusionAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

//"fetch-lessons-3d-printing"
export const fetchlesson3dPrinting = createAsyncThunk(
  "fetch-lessons-3d-printing",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lesson3dPrintingAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

//"fetch-lessons-slicing"
export const fetchlessonSlicing = createAsyncThunk(
  "fetch-lessons-slicing",
  async () => {
    try {
      const response = await API_REQUEST({
        url: lessonSlicingAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);
